import { useState } from "react";
import RTableLayout from "../../../responsive/layout/RTableLayout";
import { CMargin, DeleteIcon, DText, Flex, Row } from "../../../../styles/CommonStyles";
import Text from "../../../../core/utils/Text";
import { EditIcon } from "../../../../styles/main/setting";
import { getMainTheme } from "../../../../core/utils/theme";
import { RespIndex } from "../../../../styles/main/MainCommonStyles";
import ModalLayout from "../../../layout/main/ModalLayout";
import PackageModal from "./PackageModal";


const RPackageListTable = ({ packages, isLoading }) => {
    console.log(packages);

    const [modal, setModal] = useState({ show: false, pkg: null });
    const closeModal = () => setModal({ show: false, pkg: null });
    const openModal = (pkg) => setModal({ show: true, pkg });

    return (
        <>
            {packages?.map((pkg, idx) => (
                <Row cs={"100%"} index={idx} key={pkg.id} style={{ position: "relative" }}>
                    <CMargin margin={"4px"} />

                    <Flex justify={"space-between"}>
                        <DText fontSize={"s"} main>
                            <Text tid={"label"} /> :
                        </DText>
                        <DText fontSize={"s"} main>
                            {pkg.label}
                        </DText>
                    </Flex>

                    <CMargin margin={"6px"} />
                    <Flex justify={"space-between"} wrap>
                        <DText fontSize={"s"} main>
                            <Text tid={"description"} /> :
                        </DText>
                        <DText fontSize={"s"} main style={{ textAlign: "right" }}>
                            {pkg.description || "—"}
                        </DText>
                    </Flex>

                    <CMargin margin={"6px"} />
                    <Flex fw wrap justify={"flex-start"}>
                        <DText fontSize={"s"} main>
                            <Text tid={"options"} /> :
                        </DText>
                        <Flex fw wrap justify={"flex-start"}>
                            {pkg.options?.map((opt, i) => (
                                <Flex
                                    key={i}
                                    style={{
                                        border: "1px solid #444",
                                        borderRadius: "6px",
                                        padding: "2px 6px",
                                        margin: "2px",
                                        fontSize: "12px",
                                    }}
                                >
                                    {opt}
                                </Flex>
                            ))}
                        </Flex>
                    </Flex>

                    <CMargin margin={"6px"} />
                    <Flex justify={"space-between"}>
                        <DText fontSize={"s"} main>
                            <Text tid={"levelNumber"} /> :
                        </DText>
                        {pkg.levelNumber}
                    </Flex>

                    <CMargin margin={"6px"} />
                    <Flex justify={"space-between"}>
                        <DText fontSize={"s"} main>
                            <Text tid={"price"} /> :
                        </DText>
                        <DText fontSize={"s"} main>
                            {pkg.priceAmount} {pkg.priceCurrency}
                            {pkg.priceAmountBeforeOff
                                ? ` (${pkg.priceAmountBeforeOff})`
                                : ""}
                        </DText>
                    </Flex>

                    <CMargin margin={"6px"} />
                    <Flex justify={"space-between"}>
                        <DText fontSize={"s"} main>
                            <Text tid={"expireDays"} /> :
                        </DText>
                        <DText fontSize={"s"} main>
                            {pkg.expireDays || "∞"}
                        </DText>
                    </Flex>

                    <CMargin margin={"6px"} />
                    <Flex justify={"space-between"}>
                        <DText fontSize={"s"} main>
                            <Text tid={"status"} /> :
                        </DText>
                        <DText
                            fontSize={"s"}
                            color={pkg.isActive ? "green" : "red"}
                            main
                        >
                            <Text tid={pkg.isActive ? "active" : "inactive"} />
                        </DText>
                    </Flex>

                    <CMargin margin={"6px"} />
                    <Flex justify={"flex-end"}>
                        <EditIcon
                            size={20}
                            color={getMainTheme().active}
                            style={{ cursor: "pointer" }}
                            onClick={() => openModal(pkg, "edit")}
                        />
                        <DeleteIcon
                            size={22}
                            color="#d33"
                            onClick={() => openModal(pkg, "delete")}
                        />
                    </Flex>

                    <RespIndex>{idx + 1}</RespIndex>
                </Row>
            ))}

            <ModalLayout width={"620px"} open={modal.show} onClose={closeModal}>
                <PackageModal
                    onSuccess={closeModal}
                    _package={modal.pkg}
                    existingPackages={packages}
                    type={"edit"}
                />
            </ModalLayout>
        </>
    );
};

export default RPackageListTable;
